import React from 'react';
import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import EditAccountForm from '../../../../Components/Forms/Admin/Accounts/EditAccount';
import ModalsWrappedForm from '../../../../Components/Forms/ModalsWrappedForm';
import trans from '../../../../Translations/translation.service';
import { actions as allBusinessTypesActions } from '../../../../Redux/Api/AllBusinessTypes';
import { actions as allChannelsActions } from '../../../../Redux/Api/AllChannels';
import { actions as allIntegratorsActions } from '../../../../Redux/Api/AllIntegrators';
import { actions as allServicesActions } from '../../../../Redux/Api/AllServices';
import { actions as allShortCodesActions } from '../../../../Redux/Api/AllShortCodes';
import { actions as accountsActions, types } from '../../../../Redux/Api/Accounts';
import { PRIVATE_PATHS } from '../../../config';
import {
  ACCOUNTS_STATUSES_LIST,
  ACCOUNTS_TYPES_LIST,
  FEMALE_CODE,
  GENDERS_LIST,
} from '../../../../Constants';
import {
  ACCOUNT_FORM as form,
  ACCOUNT_PARSE_CONFIG,
  EDIT_ACTIONS,
} from '../../../../Components/Forms/Admin/Accounts/config';
import {
  catchApiItemErrors,
  parseDataForApi,
} from '../../../../Helpers';

class EditAccount extends React.Component {
  getAccount = () => {
    const { id } = this.props.match.params;

    this.props.getAccount(id);
  };

  updateAccount = account => (
    this.props.updateAccount(
      parseDataForApi(account, ACCOUNT_PARSE_CONFIG),
    ).catch(
      catchApiItemErrors,
    )
  );

  loading = () => {
    const {
      isFetchingAccount,
      isFetchingBusinessTypes,
      isFetchingChannels,
      isFetchingIntegrators,
      isFetchingServices,
      isFetchingShortCodes,
      isUpdatingAccount,
    } = this.props;
    return isFetchingAccount
      || isFetchingBusinessTypes
      || isFetchingChannels
      || isFetchingIntegrators
      || isFetchingServices
      || isFetchingShortCodes
      || isUpdatingAccount;
  };

  parseBusinessTypes = () => (
    this.props.businessTypes.map(({ id: value, name: text }) => ({
      text, value
    }))
  );

  parseChannels = () => (
    this.props.channels.map(({ account_count, name, id: value }) => {
      const resource = account_count === 1 ? 'singular.account' : 'plural.accounts';
      const text = `${
        name
      } (${
        account_count
      } ${
        trans(`resources.${resource}`)
      })`;
      return ({ text, value });
    })
  );

  parseShortCodes = () => (
    this.props.shortCodes.map(({ id: value, code: label }) => ({
      label, value,
    }))
  );

  updateSubscriptionTotalFromCredits = (credits, name, index) => {
    const { subscriptions } = this.props;
    const price = parseFloat(subscriptions[index].price);

    this.props.change(
      form,
      name.replace('credits', 'total'),
      price * parseInt(credits),
    );
  };

  updateSubscriptionTotalFromPrice = (price, name, index) => {
    const { subscriptions } = this.props;
    const credits = parseInt(subscriptions[index].credits);

    this.props.change(
      form,
      name.replace('price', 'total'),
      credits * parseFloat(price),
    );
  };

  componentDidMount() {
    this.props.fetchAllBusinessTypes();
    this.props.fetchAllChannels();
    this.props.fetchAllIntegrators();
    this.props.fetchAllServices();
    this.props.fetchAllShortCodes();
    this.getAccount();
  }

  render() {
    const { account, history, integrators, services, success } = this.props;
    const businessTypes = this.parseBusinessTypes();
    const channels = this.parseChannels();
    const shortCodes = this.parseShortCodes();
    const subject = trans('resources.singular.account');

    return (
      <ModalsWrappedForm
        gender={FEMALE_CODE}
        history={history}
        loading={this.loading()}
        open={success}
        path={PRIVATE_PATHS.adminAccounts.path}
        subject={subject}
        successMessage="successOpSingF"
        type="edit"
      >
        {
          !!integrators.length && !!services.length && account &&
          <EditAccountForm
            afterChange={{
              account: {
                subscription: {
                  subscriptions: {
                    credits: this.updateSubscriptionTotalFromCredits,
                    price: this.updateSubscriptionTotalFromPrice,
                  },
                },
              },
            }}
            actions={EDIT_ACTIONS}
            data={{
              account: {
                account_type: ACCOUNTS_TYPES_LIST,
                channel_id: channels,
                status: ACCOUNTS_STATUSES_LIST,
                'company.business_type_id': businessTypes,
                'client.person.gender': GENDERS_LIST,
                'short_codes._ids': shortCodes,
              },
            }}
            history={history}
            onSubmit={this.updateAccount}
            path={PRIVATE_PATHS.adminAccounts.path}
          />
        }
      </ModalsWrappedForm>
    );
  }
}

const selector = formValueSelector(form);

const mapStateToProps = ({
  accounts: { isFetchingItem, isUpdating, item },
  allBusinessTypes: {
    isFetching: isFetchingBusinessTypes,
    items: businessTypes,
  },
  allChannels: {
    isFetching: isFetchingChannels,
    items: channels,
  },
  allIntegrators: {
    isFetching: isFetchingIntegrators,
    items: integrators,
  },
  allServices: {
    isFetching: isFetchingServices,
    items: services,
  },
  allShortCodes: {
    isFetching: isFetchingShortCodes,
    items: shortCodes,
  },
  reduxRestResponse: { body, success, type },
  ...state
}) => ({
  body,
  isFetchingBusinessTypes,
  isFetchingChannels,
  isFetchingIntegrators,
  isFetchingServices,
  isFetchingShortCodes,
  account: item,
  businessTypes: businessTypes[1] ? businessTypes[1] : [],
  channels: channels[1] ? channels[1] : [],
  integrators: integrators[1] ? integrators[1] : [],
  isFetchingAccount: isFetchingItem,
  isUpdatingAccount: isUpdating,
  services: services[1] ? services[1] : [],
  shortCodes: shortCodes[1] ? shortCodes[1] : [],
  subscriptions: selector(state, 'subscriptions'),
  success: type === types.UPDATE_ACCOUNT && success,
});

export default connect(
  mapStateToProps,
  {
    change,
    ...accountsActions,
    ...allBusinessTypesActions,
    ...allChannelsActions,
    ...allIntegratorsActions,
    ...allServicesActions,
    ...allShortCodesActions,
  }
)(EditAccount);
